
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as editorw69p51TablTBvgn0MZLl22aKTnd6kw1LikV8d_458x7cgMeta } from "/vercel/path0/pages/editor.vue?macro=true";
import { default as protectedJqPUAvZOfFc9prjU629xpaXMX4qvQYEEfjrqx3WdQyYMeta } from "/vercel/path0/pages/protected.vue?macro=true";
import { default as indexxJcah7um1hXQj1GftpQiamd74zoDsZnowpDLy5wSU4IMeta } from "/vercel/path0/pages/chat/index.vue?macro=true";
import { default as _91uuid_93hRo9CrsMYLXqZybZsKY0aWMMzU__4519YxwYIiP_45LI0M4Meta } from "/vercel/path0/pages/chat/[uuid].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "editor",
    path: "/editor",
    meta: editorw69p51TablTBvgn0MZLl22aKTnd6kw1LikV8d_458x7cgMeta || {},
    component: () => import("/vercel/path0/pages/editor.vue")
  },
  {
    name: "protected",
    path: "/protected",
    component: () => import("/vercel/path0/pages/protected.vue")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/vercel/path0/pages/chat/index.vue")
  },
  {
    name: "chat-uuid",
    path: "/chat/:uuid()",
    component: () => import("/vercel/path0/pages/chat/[uuid].vue")
  }
]